import { render, staticRenderFns } from "./EditGroupModal.vue?vue&type=template&id=18944bac&scoped=true"
import script from "./EditGroupModal.vue?vue&type=script&lang=js"
export * from "./EditGroupModal.vue?vue&type=script&lang=js"
import style0 from "./EditGroupModal.vue?vue&type=style&index=0&id=18944bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18944bac",
  null
  
)

export default component.exports